<app-modal-container class="bg-white admin-auth-modal-shell">
  <header header>
    <div class="shrink-0 flex w-full justify-between items-center border-b border-zinc-100 px-5 py-3">
      <h3 class="text-base font-bold text-zinc-800">관리자 인증</h3>
      <button
        (click)="close()"
        class="cursor-pointer flex items-center p-1 hover:bg-zinc-100 rounded-full transition-colors">
        <app-icon name="material-symbols:close" class="size-5! text-zinc-400" />
      </button>
    </div>
  </header>

  <div class="flex-1 w-full p-6 sm:w-[320px]">
    <form [formGroup]="form" (ngSubmit)="submit()" class="flex flex-col gap-4">
      <div class="flex flex-col gap-2">
        <label for="admin-password" class="text-xs font-semibold text-zinc-500 ml-1">Password</label>
        <input
          id="admin-password"
          type="password"
          formControlName="password"
          placeholder="비밀번호"
          class="input w-full text-lg py-2.5 px-4 tracking-[0.2em] font-mono border-zinc-200 focus:border-primary-500 rounded-xl" />
      </div>
      <p class="text-[11px] text-zinc-400 leading-tight">설정 보안을 위해 관리자 비밀번호를 입력해주세요.</p>
    </form>
  </div>

  <footer footer class="shrink-0 w-full p-6 pt-0 flex justify-center">
    <button
      (click)="submit()"
      [disabled]="form.invalid"
      class="cursor-pointer bg-primary-500 disabled:bg-zinc-100 disabled:text-zinc-400 text-white text-sm font-bold py-2.5 px-10 rounded-full transition-all active:scale-[0.95] hover:brightness-105">
      인증 하기
    </button>
  </footer>
</app-modal-container>
